
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supplier-portal",
      function () {
        return require("private-next-pages/supplier-portal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supplier-portal"])
      });
    }
  